"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const Tooltip_styles_1 = require("../../components/Tooltip/Tooltip.styles");
const CustomTooltip = (_a) => {
    var { icon, text, action, placement, noFlip, onTooltipClick, onIconClick, onTextClick, onActionClick, children } = _a, props = __rest(_a, ["icon", "text", "action", "placement", "noFlip", "onTooltipClick", "onIconClick", "onTextClick", "onActionClick", "children"]);
    const { tooltipPopper, tooltip, textStyle, arrow, content, iconandAction, actionBtn } = (0, Tooltip_styles_1.default)();
    return ((0, jsx_runtime_1.jsx)(material_1.Tooltip, Object.assign({}, props, { title: (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: content, onClick: onTooltipClick, children: [icon && ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: iconandAction, onClick: onIconClick, children: icon })), text && ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: textStyle, onClick: onTextClick, children: text })), action && ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: iconandAction, children: (0, jsx_runtime_1.jsx)(material_1.IconButton, { sx: actionBtn, onClick: onActionClick, children: action }) }))] }), componentsProps: {
            popper: {
                sx: tooltipPopper,
            },
            tooltip: {
                sx: tooltip,
            },
            arrow: {
                sx: arrow,
            },
        }, PopperProps: noFlip
            ? {
                popperOptions: {
                    placement,
                    modifiers: [
                        {
                            name: 'flip',
                            options: {
                                fallbackPlacements: [placement],
                            },
                        },
                    ],
                },
            }
            : undefined, children: (0, jsx_runtime_1.jsx)("span", { children: children }) })));
};
exports.default = CustomTooltip;
